export default "__VITE_ASSET__zW1PYC9a__"